const kr = {
    9000001: "2023 크리스마스 컵",
    9000002: "슈퍼엑스 선물 거래 대회",
    9000003: "30,000USDT 대회 상금을 획득하세요",
    9000004: "참가자 수",
    9000005: "해제된 보상 풀 (USDT)",
    9000006: "선물 거래량 순위 예선 대회 ",
    9000007: "선물 수익률 순위 대회 ",
    9000008: "수익성 랭킹 경쟁 ",
    9000009: `선물 거래량 순위 경쟁을 통해 최대 <span style="color: #ffc72b;">20,000</span> USDT의 보너스 풀을 잠금 해제하세요`,
    9000010: "참가자 수에 따라 최대 20,000USDT의 상금이 주어지며, 참가자 수가 많을수록 상금의 규모도 커집니다. ",
    9000011: "상금 풀 금액",
    9000012: "活動 기간 중 매일 오전 10시 (UTC)에 업데이트됩니다",
    9000013: "보상 별",
    9000014: "통계적 선물 거래 금액",
    9000015: "보상 규칙",
    9000016: "참가자 수에 따라 최대 20,000USDT의 상금이 주어지며, 참가자 수가 많을수록 상금의 규모도 커집니다. ",
    9000017: "상금 풀 금액 (USDT)",
    9000018: "활동 수익률 순위",
    9000019: "가입",
    9000020: "활동 순익 순위",
    9000021: "마치다",
    9000022: `선물 수익률 순위 경쟁, <span style="color: #ffc72b;">{moneyPond}</span> USDT 보너스 분할 지급 `,
    9000023: `선물 수익률 랭킹 대회, <span style="color: #ffc72b;">{moneyPond}</span> USDT 보너스 지급`,
    9000024: "누적 선물 수익률 ",
    9000025: "총 선물 수익 ",
    9000026: "시작하지 않았다",
    9000027: "선물 수익률 순위 상위 50명에게 보상이 지급되며, 보너스 보상은 트레이딩 순위 보상 규정을 참조하세요.",
    9000028: "선물 수익률 기준 상위 50명의 참가자에게 보상이 지급되며, 보상을 받으려면 트레이딩 랭킹 보상 규정을 참조하세요. ",
    9000029: "활동 거래액 순위",
    9000030: "등록 성공",
    9000031: "App 다운로드",
    9000032: "홈페이지로 돌아가기",

    //合约交易积分
    9100001: '적분을 모으다',
    9100002: '공중 투하를 받다',
    9100003: '태환 보상',
    9100004: '포인트 잔액',
    9100005: '명세',
    9100006: '출석 포인트',
    9100007: '거래 포인트',
    9100008: '초대 포인트',
    9100009: '보상 포인트',
    9100010: '행운 추첨',
    9100011: '포인트 획득',
    9100012: '포인트 규칙',
    9100013: '포인트 명세',
    9100014: '당신은 신청을 해야만 이 활동에 참여할 수 있으며, 클릭하면 참여할 수 있습니다',
    9100015: '{day}일 연속 거래 및 {num}포인트 획득',
    9100016: '오늘 이미 {num} 포인트 획득',
    9100017: '포인트 보너스 풀',
    9100018: '매번 추첨 시 {point} 포인트 소모, 매일 최대 {num} 회 추첨',
    9100019: '오늘 추첨 횟수',
    9100020: '사용자',
    9100021: '포인트',
    9100022: '포인트 잔액 부족',
    9100023: '포인트 잔액 부족, 포인트 획득 후 추첨에 참여 하세요',
    9100024: '추첨 횟수가 이미 상한에 도달하였습니다.',
    9100025: '오늘 추첨 횟수가 이미 상한에 도달했으니, 내일 다시 시도해 보십시오.',
    9100026: '포인트를 얻는 방법',
    9100027: '계약거래 포인트 적립 활동에 참여하여 포인트를 적립해보세요.',
    9100028: '참여 신청 성공',
    9100029: '당신은 이미 계약 거래 포인트 획득 이벤트에 참가 신청을 하였습니다. 거래에 가서 더 많은 포인트를 획득하세요 (더 이상 캐시백 보상을 받지 않습니다)',
    9100030: '신청을 취소한 후 더 이상 포인트를 받지 못합니다. 신청을 취소하시겠습니까?',
    9100031: '거래 포인트 이벤트 센터',
    9100032: '포인트 획득',
    9100033: '당신은 신청을 해야만 이 활동에 참여할 수 있으며, 클릭하면 참여할 수 있습니다',
    9100034: '연속으로 계약 포인트에 참여하면 포인트를 획득할 수 있습니다',
    9100035: '사용자가 계약 시장에서 발생하는 모든 거래 행위로 포인트를 획득할 수 있다',
    9100036: '랭킹 포인트',
    9100037: '일일 거래 랭킹 전 5 위 및 추가 보상 포인트',
    9100038: '초대받은 사람은 포인트를 생성, 초대인은 보상 포인트를 획득할 수 있습니다',
    9100039: '{guy} 이미 당첨<span style="color:#D9A31A"> {num} 포인트</span>',
    9100040: '지금 추첨',
    9100041: '획득을 축하합니다',
    9100042: '모든 유형',
    9100043: '이 페이지에 머물다',
    9100044: '등록에 참여',
    9100045: '계속 거래하세요',
    9100046: '현재 진행중인 활동은 없습니다. 많은 관심 부탁드립니다.',
    9100047: 'SCS 토큰 교환',
    9100048: '',
    9100049: '',

    9100050: '날짜',
    9100051: '시작 날짜',
    9100052: '종료 시간',
    9100053: 'to',
    9100054: '유형',

    9100055: '획득 포인트 = 거래량 * 1% (플랫폼의 총 거래량이 증가함에 따라 난이도는 추가 조정됩니다.)',
    9100056: '예: 사용자는 마진이 100USDT*100X=10000U인 포지션을 사용합니다.',
    9100057: '그런 다음 100포인트를 얻으려면 100USDT의 보증금만 있으면 됩니다. ',
    9100058: '거래 포인트는 플랫폼 토큰 SCS를 얻을 수 있는 유일한 방법입니다',
    9100059: '추가 보너스 포인트 = 당일 총 포인트 * 순위 보상 비율',
    9100060: '순위',
    9100061: '일등',
    9100062: '2등',
    9100063: '삼등',
    9100064: '넷째',
    9100065: '다섯 번째',
    9100066: '초대받은 사람은 포인트를 생성, 초대인은 보상 포인트를 획득할 수 있습니다',
    9100067: '등급계수',
    9100068: '계산식: 획득한 승급 포인트 = 초대 대상자가 획득한 포인트 * 레벨 계수',
    9100069: '레벨 계수는 실제 상황에 따라 조정됩니다.',
    9100070: `예: 사용자 B가 포인트 활동에 참여하고 초대자는 사용자 A이고 사용자 A의 초대 수가 레벨 3에 도달했으며 사용자 B는 누적 포인트 = 360,000입니다.`,
    9100071: '그러면 사용자 A가 획득할 수 있는 누적 프로모션 포인트 = 360000* 30% = 108,000',
    9100072: '보상계수',
    9100073: '거래 사용자 1명',
    9100074: '거래량이 500W에 도달',
    9100075: '거래량이 2000W에 도달',

    9100076: '전송',

    //热币
    9100080: '이벤트가 종료되었습니다',
    9100081: '"참가 신청"을 클릭하여 대상을 획득',
    9100082: '규칙 보기',
    9100083: '참가 신청',
    9100084: '활동',
    9100088: '거래',
    9100089: '보증금',
    9100090: '이벤트에 등록되었습니다',

    9100091: '이벤트가 중료 되었습니다，다음 이벤트를 기다려 주세요！',
    9100092: '행사가 아직 시작되지 않았으니 기다려주시기 바랍니다.',
    9100093: '',
    9100094: '',

    //自由区二维码分享页面
    9100095: '자유 구역 상장, 부의 자유 시작',
    9100096: '앱 열기',
    9100097: '',
    9100098: '',
}
export default kr



// WEBPACK FOOTER //
// ./src/i18n/langs/languageJame/kr.js